import Vue from 'vue'
import Config from '@/config'
import axios from 'axios'
import {
  getNowFormatDate,
  funcUrlDel
} from '@/libs/utils'
import md5 from 'vux/src/tools/md5/index.js'
import qs from 'qs'
import Storage from '@/storage'
import AlertModule from 'vux/src/plugins/alert/index.js'
import ToastModule from 'vux/src/plugins/toast/index.js'
import LoadingModule from 'vux/src/plugins/loading/index.js'
import ConfirmModule from 'vux/src/plugins/confirm/index.js'
Vue.use(AlertModule)
Vue.use(ToastModule)
Vue.use(LoadingModule)
Vue.use(ConfirmModule)

let request = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? Config.baseUrl : '/api/',
  timeout: 60000
})
let loadCount = 0
request.interceptors.request.use(
  cfg => {
    cfg.headers = {
      'Content-Type': cfg.contentType || 'application/x-www-form-urlencoded',
      'token': Storage.get('token'),
      'accountid': Storage.get('myaccountid') || ''
    }
    if (!cfg.contentType) {
      if (!cfg.data) cfg.data = {}
      if (!cfg.isMd5) {
        Object.assign(cfg, {
          data: qs.stringify(cfg.data)
        })
      } else {
        let reqdata = JSON.stringify(cfg.data)
        let timestamp = getNowFormatDate()
        let sign = md5(timestamp + Config.secret + reqdata)
        Object.assign(cfg, {
          data: {
            sign: sign,
            timestamp: timestamp,
            data: reqdata
          }
        })
        Object.assign(cfg, {
          data: qs.stringify(cfg.data)
        })
      }
    }
    loadCount++
    Vue.$vux.loading.show({
      text: '加载中...'
    })
    return cfg
  },
  error => {
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  response => {
    loadCount--
    if (!loadCount) {
      Vue.$vux.loading.hide()
    }
    let res = response.data
    let noError = response.config.noError // 有些报error也不要弹出|| typeof res === 'object'
    if (res.success || res.success === 'true' || res === '0000' || res.status === 'suc' || typeof res === 'string' || noError === true || res.total) {
      if (res.errorCode === '611') {
        /* #TODO 开发环境时注释下一行代码，正式环境打包时取消注释 */
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + Config.appid + '&redirect_uri=' + funcUrlDel('code') + '/&response_type=code&scope=snsapi_base&state=200&connect_redirect=1#wechat_redirect'
      }
      return res
    } else {
      if (res.errorCode === '611') {
        /* #TODO 开发环境时注释下一行代码，正式环境打包时取消注释 */
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + Config.appid + '&redirect_uri=' + funcUrlDel('code') + '/&response_type=code&scope=snsapi_base&state=200&connect_redirect=1#wechat_redirect'
      } else {
        Vue.$vux.alert.show({
          title: response.config.msgTitle || '提示信息',
          content: res.msg || res.message || '服务器出现错误，请稍后重试',
          onShow () { },
          onHide () { }
        })
      }
      return Promise.reject(res)
    }
  },
  error => {
    loadCount--
    if (!loadCount) {
      Vue.$vux.loading.hide()
    }
    if (!error.response) {
      Vue.$vux.alert.show({
        title: '响应超时',
        content: '服务器响应超时，请稍后重试',
        onShow () { },
        onHide () { }
      })
    } else {
      Vue.$vux.alert.show({
        title: '请求出错',
        content: '服务器出现错误，请稍后重试',
        onShow () { },
        onHide () { }
      })
    }
    return Promise.reject(error)
  }
)

export default request
